import { Component, Input, EventEmitter, OnInit, Output } from '@angular/core';
import { Edge } from 'vis-network';
import { Node } from 'neovis.js';
import { NodeAndLinks } from '../neovis-graph/neovis-graph.component';

@Component({
  selector: 'app-graph-component',
  templateUrl: 'graph.component.html',
  styleUrls: ['./graph.component.css'],
})
export class GraphComponent implements OnInit {
  @Output() goBack = new EventEmitter<boolean>();
  showGraph3d = false;
  @Input() element: any = null;
  constructor() {}

  ngOnInit(): void {
    console.log('GRAPH COMPONENT', this.element);
  }

  toggleGraph() {
    this.showGraph3d = !this.showGraph3d;
  }

  nodes: Node[] = [];
  links: Edge[] = [];
  onNodesAndLinks(nodeAndLinks: NodeAndLinks) {
    this.nodes = nodeAndLinks.nodes;
    this.links = nodeAndLinks.links;
  }

  goBackFunc() {
    this.goBack.emit(true);
  }
}
